<template>
  <div>
    <HeaderContent variant="primaria" />
    <ClientOnly>
      <div class="fixed inset-x-0 top-0 z-40 pointer-events-none print:hidden">
        <div class="transition-transform duration-500 ease-out"
          :class="{ '-translate-y-full': !isScrolled, 'translate-y-0': isScrolled }">
          <HeaderContent variant="secundaria" class="pointer-events-auto" />
        </div>
      </div>
    </ClientOnly>

    <ClientOnly>
      <USlideover v-model:open="uiStore.openSlideoverMainMenu"
                  :ui="{
                    content: 'max-w-xs bg-gradient-to-b from-[#039B75] to-[#01365A] !right-0 !mr-0',
                    header: 'hidden',
                    body: 'flex flex-col flex-col-1 justify-between p-2 sm:p-2'}">
        <template #body>
          <HeaderMainMenu variant="primaria" orientation="vertical" />
          <div class="w-full flex flex-row-reverse">
            <UButton icon="ph:x" @click.="uiStore.openSlideoverMainMenu = false"
                   color="neutral" size="xl" variant="outline" />
          </div>

        </template>
      </USlideover>
    </ClientOnly>

    <Auth :text-class="textClass"/>
    <AuthForgotPassword />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted, onBeforeUnmount } from "vue";

const uiStore = useUiStore(); // Instancia a Store
const isScrolled = ref(false)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 100
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

// textClass agora reage diretamente à store
const textClass = computed(() => uiStore.openSlideoverMainMenu ? 'text-white' : 'text-gray-700')
</script>

<style scoped>
:deep(.menu-mobile ul li) {
  padding-bottom: 5px;
  margin-bottom: 20px !important;
  border-bottom: 1px solid #ccc;
  width: 100%;
}
</style>